import React from 'react';
import { Navbar, Nav, Container, Button } from 'react-bootstrap';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { isAuthenticated, clearAuthData, getStoredUser } from '../utils/auth';

function Navigation() {
  const navigate = useNavigate();
  const location = useLocation();
  const authenticated = isAuthenticated();
  const user = getStoredUser();

  const handleLogout = () => {
    clearAuthData();
    navigate('/login');
  };

  return (
    <Navbar bg="dark" variant="dark" expand="lg" sticky="top">
      <Container>
        <Navbar.Brand as={Link} to="/">
          <img
            src={`${process.env.PUBLIC_URL}/ursulai-logo-small.png`}
            alt="UrsulaI"
            height="30"
            className="d-inline-block align-top me-2"
            onError={(e) => {
              e.target.style.display = 'none';
              console.error('Logo failed to load');
            }}
          />
          UrsulaI
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link as={Link} to="/" active={location.pathname === '/'}>
              Home
            </Nav.Link>
            <Nav.Link as={Link} to="/marketplace" active={location.pathname === '/marketplace'}>
              Marketplace
            </Nav.Link>
            {authenticated && (
              <Nav.Link as={Link} to="/dashboard" active={location.pathname === '/dashboard'}>
                Dashboard
              </Nav.Link>
            )}
          </Nav>
          <Nav>
            {authenticated ? (
              <>
                <Navbar.Text className="me-3">
                  Signed in as: <strong>{user?.username || 'User'}</strong>
                </Navbar.Text>
                <Button variant="outline-light" size="sm" onClick={handleLogout}>
                  Logout
                </Button>
              </>
            ) : (
              <Button variant="primary" size="sm" onClick={() => navigate('/login')}>
                Sign In
              </Button>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Navigation;
